import React from 'react';
import { 
  Box, 
  Typography, 
  Grid, 
  Paper, 
  Chip,
  MenuItem,
  Select,
  FormControl 
} from '@mui/material';
import moment from 'moment';
import Icon from './Icon';
import { updateHPDTicket } from '../../../../../../../sevices/violationsApi';
import { useParams } from 'react-router-dom';
import { isAdmin } from '../../../../../../../utils/helpers';
import StatusCard from './StatusCard';
import useCustomMutate from '../../../../../../../hooks/useMutate';

const ViolationInfoCard = ({ violation, onStatusChange, refetch }) => {
  const { id } = useParams();
  const { mutate: updateViolation } = useCustomMutate(
    (data) => updateHPDTicket(id, data),
    ["hpd-tickets"],
    () => {
      refetch();
    }
  );

  const handleStatusChange = (event) => {
    updateViolation({ status: event.target.value });
  };

  return (
    <Paper className="violation-details-card">
      <Grid container spacing={2}>
        {/* Building */}
        <Grid item xs={12} md={2} className="d-flex align-items-center">
          <Box className="icon-container">
            <Icon type="building" />
          </Box>
          <Box className="detail-section">
            <Typography className="detail-label">Building</Typography>
            <Box className="building-icon-container">
              <Typography className="detail-value">
                {violation?.building_address || "N/A"}
              </Typography>
            </Box>
          </Box>
        </Grid>

        {/* Unit */}
        <Grid item xs={12} md={2} className="d-flex align-items-center">
          <Box className="icon-container">
            <Icon type="home-check" />
          </Box>
          <Box className="detail-section">
            <Typography className="detail-label">Unit</Typography>
            <Box className="unit-icon-container">
              <Chip
                label={violation?.unit_number || "N/A"}
                className="unit-chip"
              />
            </Box>
          </Box>
        </Grid>

        {/* Violation Number */}
        <Grid item xs={12} md={2} className="d-flex align-items-center">
          <Box className="icon-container">
            <Icon type="exclamation" />
          </Box>
          <Box className="detail-section">
            <Typography className="detail-label">Vio#</Typography>
            <Box className="violation-number-container">
              <Typography className="detail-value">
                {violation?.violation_id || "N/A"}
              </Typography>
            </Box>
          </Box>
        </Grid>

        {/* Violation Code */}
        <Grid item xs={12} md={2} className="d-flex align-items-center">
          <Box className="icon-container">
            <Icon type="checkup" />
          </Box>
          <Box className="detail-section">
            <Typography className="detail-label">Vio Code</Typography>
            <Box className="violation-code-container">
              <Typography className="detail-value">
                {violation?.violation_code || "N/A"}
              </Typography>
            </Box>
          </Box>
        </Grid>

        {/* Created Date */}
        <Grid item xs={12} md={2} className="d-flex align-items-center">
          <Box className="icon-container">
            <Icon type="calendar" />
          </Box>
          <Box className="detail-section">
            <Typography className="detail-label">Created On</Typography>
            <Box>
              <Typography className="detail-value">
                {moment(violation?.created_at).format("MM/DD/YYYY") || "N/A"}
              </Typography>
            </Box>
          </Box>
        </Grid>

        {/* Status */}
        <Grid item xs={12} md={2}>
          {isAdmin() ? (
            <Box className="detail-section">
              <Typography className="detail-label">Status</Typography>
              <Box>
                <FormControl fullWidth variant="outlined" size="small">
                  <Select
                    value={violation.status}
                    onChange={handleStatusChange}
                    className="status-select"
                  >
                    <MenuItem value="pending">
                      Pending
                    </MenuItem>
                    <MenuItem value="docs_required">
                      Docs Required
                    </MenuItem>
                    <MenuItem value="submitted">
                      Submitted
                    </MenuItem>
                    <MenuItem value="vio_removed">
                      Vio Removed
                    </MenuItem>
                    <MenuItem value="rejected">
                      Rejected
                    </MenuItem>
                    <MenuItem value="overdue">
                      Overdue
                    </MenuItem>
                    <MenuItem value="req_dismissal">
                      Req Dismissal
                    </MenuItem>
                  <MenuItem value="defect_status">
                    Defect Status
                  </MenuItem>
                  <MenuItem value="abate_req">
                    Abatement Required
                  </MenuItem>
                  <MenuItem value="abate_prog">
                    Abatement In Progress
                  </MenuItem>
                  <MenuItem value="insp_req">
                    Inspection Requested
                  </MenuItem>
                  <MenuItem value="insp_scheduled">
                    Inspection Scheduled
                  </MenuItem>
                  <MenuItem value="o_affidavit_req">
                    Owner Affidavit Required
                  </MenuItem>
                  <MenuItem value="vendor_docs">
                    Vendor Docs
                  </MenuItem>
                  <MenuItem value="reg_expired">
                    Registration Expired
                  </MenuItem>
                  <MenuItem value="t_denied_access">
                    Tenant Denied Access
                  </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Box>
          ) : (
            <Box className="detail-section">
              <StatusCard status={violation.status} />
            </Box>
          )}
        </Grid>
      </Grid>

      {/* Dates and Description */}
      <Box className="dates-description-section">
        <Box className="dates-container">
          <Box className="date-item">
            <Typography className="date-label">Correct by</Typography>
            <Typography className="date-value">
              {moment(violation?.correct_by_date).format("MM/DD/YYYY") || "N/A"}
            </Typography>
          </Box>
          <Box className="date-item">
            <Typography className="date-label">Certify by</Typography>
            <Typography className="date-value">
              {moment(violation?.certify_by_date).format("MM/DD/YYYY") || "N/A"}
            </Typography>
          </Box>
        </Box>
        <Typography className="violation-description">
          {violation?.description || ""}
        </Typography>
      </Box>
    </Paper>
  );
};

export default ViolationInfoCard; 